import { render, staticRenderFns } from "./autoria-libre.vue?vue&type=template&id=36b859ac"
import script from "./autoria-libre.vue?vue&type=script&lang=js"
export * from "./autoria-libre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports